var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"max-width":"500"}},[_c('apexchart',{attrs:{"type":"bar","width":"100%","options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }